export default __webpack_public_path__ + "static/media/soccer.a3285152.svg";